/* global google */

'use strict';

module.exports = ['$scope', 'NgMap', 'translateFilter', function ($scope, NgMap, translateFilter) {

        if ($scope.showLenght === undefined) {
            $scope.showLenght = false;
        }

        if (!$scope.showTrafficLayer === undefined) {
            $scope.showTrafficLayer = false;
        }

        if (!$scope.showTransitLayer === undefined) {
            $scope.showTransitLayer = false;
        }

        if (!$scope.creatingRoute === undefined) {
            $scope.creatingRoute = false;
        }

        if (!$scope.noDirection === undefined) {
            $scope.noDirection = true;
        }

        $scope.selectedShape;
        $scope.selectedMarkerShape;

        $scope.myMap;

        var directionsDisplay;
        var directionsService;
        var drawingManager;
        var currentPolylineRoute;
        var routeStart;
        var routeEnd;

        /**
         * data layer per inserire i pin delle location trovate tramite searchBox
         * @type google.maps.Data
         */
        var searchBoxDataLayer = new google.maps.Data();

        var theWaypoints = [];

        var trafficLayer = new google.maps.TrafficLayer();
        var transitLayer = new google.maps.TransitLayer();


//        var inputSearchBox = document.getElementById('mapAddressAutocomplete');
//        var searchBox = new google.maps.places.SearchBox(inputSearchBox);
//
//        var originInput = document.getElementById('origin-input');
//        var destinationInput = document.getElementById('destination-input');
//        var directionBox = document.getElementById('direction-box');


        var directionsService = new google.maps.DirectionsService;
        var directionsRenderer = new google.maps.DirectionsRenderer;

        var markerInfoWindow = new google.maps.InfoWindow({
            content: ""
        });

        var featureInfoWindow = new google.maps.InfoWindow({
            content: ""
            , pixelOffset: new google.maps.Size(0, -35)
        });

        var polyOptions = {
            strokeWeight: 0,
            fillOpacity: 0.45,
            editable: $scope.parentObjEditable,
            draggable: $scope.parentObjEditable
        };

        // in totale 20 layer per dati opzionali
        var maxOptionalLayer = 20;
        var optionalLayers = [];
        var optionalLayersLoaded = false;
        // layer con cluster
        var clusterImagePath = "./assets/resources/ngDro-gMapModule/assets/statics/img/marker_cluster/m";


//        // true per il public site
//        var showPublicInfoWindow = false;


        function getLayerIcon(myLayer, feature) {
            var icon = undefined;
            if (myLayer.icon) {
                icon = {
                    url: "./assets/resources/ngDro-gMapModule/assets/statics/img/public_ico/" + myLayer.icon + ".png",
                    scaledSize: new google.maps.Size(42, 42)
                };
            } else {
                if (feature && feature.getProperty('icon')) {

                    icon = {
                        url: "./assets/resources/ngDro-gMapModule/assets/statics/img/public_ico/" + feature.getProperty('icon') + ".png",
                        scaledSize: new google.maps.Size(42, 42)
                    }

                }

            }

            return icon;
        }


        function dataLayerMouseOver(feature) {
            var infoBox = document.getElementById('info-box');
            if (infoBox && infoBox !== null) {
                document.getElementById('info-box').textContent =
                        feature.feature.getProperty('description');
            }
        }

        function dataLayerMouseClick(feature, isFeature) {
            var content = "";
            var description = "";
            var infoPosition;

            if (isFeature) {
                description = feature.feature.getProperty('description');
                infoPosition = feature.latLng;
            } else {
                // marker
                description = feature.description;
                infoPosition = feature.position;
            }

            if ($scope.featureShowDblclickOnInfowindow) {
                content = "<div><p>" + description + "</p>"
                        + "<p>" + translateFilter('gMapModule.dblClick4Details') + "</p></div>";
            } else {
                content = "<div><p>" + description + "</p></div>";
            }

            featureInfoWindow.setContent(content);
            featureInfoWindow.setPosition(infoPosition);

            //prima di aprire l'infoWindow verifico la risoluzione, così la visualizzo correttamente anche su device e catturo anche la rotazione
            var windowWidth = $(window).outerWidth();
            var infoWindowOptions = {
                maxWidth: windowWidth - 150
            };
            featureInfoWindow.setOptions(infoWindowOptions);

            featureInfoWindow.open($scope.myMap);
        }

        function loadOptionalLayer() {

            if (!optionalLayersLoaded) {
                for (var i = 0; i < maxOptionalLayer; i++) {
                    optionalLayers.push({});
                }

                angular.forEach($scope.objLayers, function (myLayer) {
                    var js = {
                        "type": "FeatureCollection",
                        "features": myLayer.jsonLayer
                    };

                    var newLayer = new google.maps.Data();
                    newLayer.addGeoJson(js);
                    newLayer.isCluster = myLayer.cluster;
                    newLayer.setStyle(function (feature) {
                        return {icon: getLayerIcon(myLayer, feature)};
                    });


                    if (myLayer.cluster === false) {

                        newLayer.markerCluster = [];

                        // Set mouseover event for each feature.
                        newLayer.addListener('mouseover', function (feature) {
                            dataLayerMouseOver(feature);
                        });

                        // Set mouse click event for each feature.
                        newLayer.addListener('click', function (feature) {
                            dataLayerMouseClick(feature, true);
                        });

                        // Set mouse doubleclick event for each feature.
                        newLayer.addListener('dblclick', function (feature) {
                            $scope.featureOpenEvent({feature: feature, isMarker: false});
                        });
                    }

                    optionalLayers[myLayer.idx] = newLayer;

                });

                optionalLayersLoaded = true;
            }
        }

        function clusterAddMarkers(myLayer) {

            var allMarker = [];

            myLayer.forEach(function (feature) {

                var geom = feature.getGeometry();
                var markerPos = new google.maps.LatLng(geom.b.lat(), geom.b.lng());

                var marker = new google.maps.Marker({
                    id: feature.getProperty('id'),
                    itemId: feature.getProperty('itemId'),
                    position: markerPos,
                    title: "",
                    description: feature.getProperty('description'),
                    icon: getLayerIcon(myLayer, feature),
                    type: feature.getProperty('type')
                });

                // Set mouseover event for each feature.
                marker.addListener('mouseover', function () {
                    dataLayerMouseOver(this);
                });

                // Set mouse click event for each feature.
                marker.addListener('click', function () {
                    dataLayerMouseClick(this, false);
                });

                // Set mouse doubleclick event for each feature.
                marker.addListener('dblclick', function () {
                    $scope.featureOpenEvent({feature: this, isMarker: true});
                });

                allMarker.push(marker);
            });

            var markerClusterer = new MarkerClusterer($scope.myMap, allMarker, {imagePath: clusterImagePath});
            myLayer.markerCluster = markerClusterer;

        }

        function clusterRemoveMarkers(myLayer) {
            if (myLayer && myLayer.markerCluster) {
                myLayer.markerCluster.clearMarkers();
            }
        }

        function showHideOptionalLayers() {
            if ($scope.objLayers && $scope.objLayers.length > 0) {

                loadOptionalLayer();
                for (var i = 0; i < maxOptionalLayer; i++) {
                    if ($scope.objLayers[i] && optionalLayers[i] && !angular.equals(optionalLayers[i], {})) {

                        if ($scope.objLayers[i].showLayer === true) {
                            if (optionalLayers[i].isCluster === false) {
                                optionalLayers[i].setMap($scope.myMap);
                            } else {
                                clusterAddMarkers(optionalLayers[i]);
                            }
                        } else {
                            if (optionalLayers[i].isCluster == false) {
                                optionalLayers[i].setMap(null);
                            } else {
                                clusterRemoveMarkers(optionalLayers[i]);
                            }
                        }
                    }
                }
            }
        }

        NgMap.getMap($scope.mapId).then(function (map) {

            $scope.myMap = map;

            // rimuovo i div aggiunti da google maps
            var myEl = angular.element(document.getElementsByClassName("pac-logo"));
            myEl.remove();


            //$scope.myMap.setOptions({gestureHandling: 'greedy'});            
            $scope.myMap.setOptions({
                scrollwheel: $scope.useScrollWheel !== undefined ? $scope.useScrollWheel : false,
                mapTypeControl: $scope.showMapTypeControl !== undefined ? $scope.showMapTypeControl : true,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scaleControl: $scope.scaleControl !== undefined ? $scope.scaleControl : true,
                fullscreenControl: $scope.showFullscreenControl !== undefined ? $scope.showFullscreenControl : true,
                fullscreenControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_BOTTOM
                },
                zoomControl: $scope.showZoomControl !== undefined ? $scope.showZoomControl : true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                streetViewControl: $scope.showStreetViewControl !== undefined ? $scope.showStreetViewControl : true,
                streetViewControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                }
            });


            directionsDisplay = new google.maps.DirectionsRenderer({
                draggable: $scope.parentObjEditable,
                map: map
            });

            directionsService = new google.maps.DirectionsService;

            directionsDisplay.addListener('directions_changed', function () {

                if (directionsDisplay && directionsDisplay.directions
                        && directionsDisplay.directions.routes
                        && directionsDisplay.directions.routes[0]) {

                    currentPolylineRoute = getPolyline(directionsDisplay.directions.routes[0]);
                } else {
                    currentPolylineRoute = null;
                }

                $scope.directionsChanged({route: currentPolylineRoute, waypoint: theWaypoints});

                if (currentPolylineRoute !== undefined) {
                    map.setCenter(currentPolylineRoute.getPath().getAt(currentPolylineRoute.getPath().getLength() - 1));
                    if (map.getZoom < 10) {
                        map.setZoom(10);
                    }
                }

            });

//            map.addListener('bounds_changed', function () {
//                searchBox.setBounds(map.getBounds());
//                $scope.mapBoundChangeEvent({mapbounds: map.getBounds()});
//            });


            if ($scope.showDrawing) {
                drawingManager = new google.maps.drawing.DrawingManager({
                    drawingControlOptions: {
                        position: google.maps.ControlPosition.RIGHT_BOTTOM,
                        drawingModes: []
                    },
                    drawingMode: null,
                    markerOptions: {
                        draggable: $scope.parentObjEditable
                    },
                    polylineOptions: {
                        editable: $scope.parentObjEditable,
                        draggable: $scope.parentObjEditable
                    },
                    rectangleOptions: polyOptions,
                    circleOptions: polyOptions,
                    polygonOptions: polyOptions,
                    map: map
                });

                google.maps.event.addListener(drawingManager, 'overlaycomplete', function (e) {
                    onOverlayComplete(e);
                });
                // Clear the current selection when the drawing mode is changed, or when the map is clicked.
                google.maps.event.addListener(drawingManager, 'drawingmode_changed', clearSelection);
            }

            google.maps.event.addListener(map, 'click', onMapClick);


            // ******************************************************
            // load parent directions
            // ******************************************************            
            if ($scope.directions
                    && $scope.directions.originLat && $scope.directions.originLng
                    && $scope.directions.destinationLat && $scope.directions.destinationLng) {

                var origin = new google.maps.LatLng($scope.directions.originLat, $scope.directions.originLng);
                var destination = new google.maps.LatLng($scope.directions.destinationLat, $scope.directions.destinationLng);

                // devono essere marker (MAX 20)
                if ($scope.directions.wayPoints) {

                    var wPointIncrement = 1;
                    if ($scope.directions.wayPoints.length > 20) {
                        wPointIncrement = Math.floor($scope.directions.wayPoints.length / 20) + 2;
                    }

                    // waypoint per route
                    for (var i = 2; i < $scope.directions.wayPoints.length - 2; i += wPointIncrement) {
                        var obj = $scope.directions.wayPoints[i];
                        var newMark = new google.maps.Marker({
                            title: obj.lat.toString() + " " + obj.lng.toString(),
                            position: new google.maps.LatLng(obj.lat, obj.lng),
                            onRoute: true,
                            isEndpoint: false,
                            map: $scope.myMap
                        });
                        theWaypoints.push(newMark);
                    }
                }
                displayRoute(origin, destination);
            }

            // ******************************************************
            // load parent shapes
            // ******************************************************
            angular.forEach($scope.shapes, function (obj) {

                var newShape = {};

                switch (obj.shapeType) {
                    case 'rectangle':
                        newShape = new google.maps.Rectangle({
                            bounds: obj.vertex,
                            editable: $scope.parentObjEditable,
                            draggable: $scope.showDrawing,
                            type: google.maps.drawing.OverlayType.RECTANGLE,
                            map: map
                        });
                        break;

                    case 'polygon':
                        newShape = new google.maps.Polygon({
                            paths: obj.vertex,
                            editable: $scope.parentObjEditable,
                            draggable: $scope.showDrawing,
                            type: google.maps.drawing.OverlayType.POLYGON,
                            map: map
                        });
                        break;
                }

                addShapeListener(newShape);
            });

            processMarkers();
            $scope.showHideTrafficLayer();
            $scope.showHideTransitLayer();
            showHideOptionalLayers();

            //controlli CALCOLO PERCORSO
//            $scope.myMap.controls[google.maps.ControlPosition.TOP_RIGHT].push(inputSearchBox);
            $scope.myMap.controls[google.maps.ControlPosition.TOP_RIGHT].push(directionBox);

            $scope.mapReady();

        }); // getMap end



        // **************************************************************************
        // ******************************** ADDRESS SEARCH BOX **********************
        // **************************************************************************




        $scope.searchBoxSearchPlace = function () {
            var places = searchBox.getPlaces();

            if (places.length === 0) {
                return;
            }

            // Create a FEATURE for each place.
            var features = [];

            var bounds = new google.maps.LatLngBounds();
            places.forEach(function (place) {
                if (!place.geometry) {
                    return;
                }
                var newFeature = {
                    "type": "Feature",
                    "properties": {
                        "description": place.name
                    },
                    "geometry": {
                        "type": "Point",
                        "coordinates": [place.geometry.location.lng(), place.geometry.location.lat()]
                    }
                };

                features.push(newFeature);

                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }

            });
            $scope.myMap.fitBounds(bounds);

            //costruisco il geoJSON relativo alle features
            var js = {
                "type": "FeatureCollection",
                "features": features
            };
            //SETTO IL DATA LAYER searchBox
            searchBoxDataLayer.setMap(null);
            searchBoxDataLayer = new google.maps.Data();
            searchBoxDataLayer.setStyle({icon: {
                    url: "./assets/resources/ngDro-gMapModule/assets/statics/img/public_ico/search_box.png",
                    scaledSize: new google.maps.Size(48, 48)
                }});
            searchBoxDataLayer.addGeoJson(js);
            searchBoxDataLayer.isCluster = false;

            searchBoxDataLayer.markerCluster = [];

            // Set mouseover event for each feature.
            searchBoxDataLayer.addListener('mouseover', function (feature) {
                dataLayerMouseOver(feature);
            });

            // Set mouse click event for each feature.
            searchBoxDataLayer.addListener('click', function (feature) {
                dataLayerMouseClick(feature, true);
            });

            // Set mouse doubleclick event for each feature.
            searchBoxDataLayer.addListener('dblclick', function (feature) {
                $scope.featureOpenEvent({feature: feature, isMarker: false});
            });


            searchBoxDataLayer.setMap($scope.myMap);

        };
        //searchBox.addListener('places_changed', $scope.searchBoxSearchPlace);


        // **************************************************************************
        // ***************************CALCOLO PERCORSO*******************************
        // **************************************************************************


        $scope.travelMode = 'DRIVING';
        $scope.routeResult = '';
        $scope.directionBoxStatus = {
            open: false
        };
        var originPlace;
        var destinationPlace;

        var searchBox;

        var originAutocomplete;
        var destinationAutocomplete;

        var directionBox = document.getElementById('direction-box');

        $scope.$watch("directionBoxStatus['open']", function () {
            
            if ($scope.directionBoxStatus.open) {
                //inizializzo tutte le variabili per la ricerca percorso
                var inputSearchBox = document.getElementById('mapAddressAutocomplete');
                searchBox = new google.maps.places.SearchBox(inputSearchBox);
                searchBox.addListener('places_changed', $scope.searchBoxSearchPlace);
                $scope.myMap.addListener('bounds_changed', function () {
                    searchBox.setBounds($scope.myMap.getBounds());
                    $scope.mapBoundChangeEvent({mapbounds: $scope.myMap.getBounds()});
                });

                var originInput = document.getElementById('origin-input');
                var destinationInput = document.getElementById('destination-input');


                originAutocomplete = new google.maps.places.Autocomplete(originInput);
                destinationAutocomplete = new google.maps.places.Autocomplete(destinationInput);
                originAutocomplete.bindTo('bounds', $scope.myMap);
                destinationAutocomplete.bindTo('bounds', $scope.myMap);

                setupPlaceChangedListener(originAutocomplete, 'ORIG');
                setupPlaceChangedListener(destinationAutocomplete, 'DEST');
            }
        });


        function route() {
            var resultMsg = "";

            if (!originPlace || !destinationPlace) {
                //$scope.routeResult = translateFilter('gMapModule.routeSelectOption');
                return;
            }

            var origin = {};
            if (originPlace.place_id) {
                origin = {
                    'placeId': originPlace.place_id
                };
            } else {
                if (originPlace.name) {
                    origin = originPlace.name;
                }
            }
            var destination = {};
            if (destinationPlace.place_id) {
                destination = {
                    'placeId': destinationPlace.place_id
                };
            } else {
                if (destinationPlace.name) {
                    destination = destinationPlace.name;
                }
            }

            directionsService.route(
                    {
                        origin: origin,
                        destination: destination,
                        travelMode: $scope.travelMode,
                        region: "it"
                    },
                    function (response, status) {
                        if (status === 'OK') {
                            //me.directionsRenderer.setDirections(response);
                            if (!directionsRenderer.getMap()) {
                                directionsRenderer.setMap($scope.myMap);
                            }
                            directionsRenderer.setDirections(response);

                            console.log("TESTBAR response", response);

                            if (response.routes.length > 0
                                    && response.routes[0].legs.length > 0
                                    && resultMsg + response.routes[0].legs[0]
                                    && resultMsg + response.routes[0].legs[0].duration
                                    && resultMsg + response.routes[0].legs[0].distance
                                    ) {
                                resultMsg = '<b>' + response.routes[0].legs[0].duration.text + " - " + response.routes[0].legs[0].distance.text + '</b><br>'
                                        + '<b>' + response.routes[0].summary + '</b><br><br>'
                                        ;
                                if (response.routes[0].legs[0].steps) {
                                    angular.forEach(response.routes[0].legs[0].steps, function (step) {
                                        resultMsg = resultMsg + step.instructions + '<br>';
                                    });
                                }
                            }
                            $scope.routeResult = resultMsg;

                        } else
                        {
                            switch (status) {
                                case 'UNKNOWN_ERROR':
                                case 'OVER_QUERY_LIMIT':
                                case 'REQUEST_DENIED':
                                case 'INVALID_REQUEST':
                                    resultMsg = translateFilter('gMapModule.routeError');
                                    break;
                                case 'ZERO_RESULTS':
                                case 'NOT_FOUND':
                                    resultMsg = translateFilter('gMapModule.routeNoResult');
                                    break;

                            }

                            $scope.routeResult = resultMsg;
                        }

                    });
        };

        $scope.searchDirection = function (mode) {
            if (mode){
                $scope.travelMode = mode;
            } 
            originPlace = originAutocomplete.getPlace();
            destinationPlace = destinationAutocomplete.getPlace();
            
            route();
        };


        function setDirectionAutocomplete(autocomplete, mode) {
            var place = autocomplete.getPlace();
            if (mode === 'ORIG') {
                originPlace = place;
            } else {
                destinationPlace = place;
            }
            route();

        }
        function setupPlaceChangedListener(autocomplete, mode) {

            autocomplete.addListener('place_changed', function () {
                setDirectionAutocomplete(autocomplete, mode);
            });
        }
        ;

        // **************************************************************************


// **************************************************************************
// ******************************** DRAWING TOOLBAR *************************
// **************************************************************************

        $scope.mapDrawingMarker = function (drawingType) {

            if (drawingManager === undefined) {
                return;
            }

            if (drawingType === null) {
                drawingManager.setDrawingMode(null);
                return;
            }

            $scope.creatingRoute = false;

            switch (drawingType) {
                case 'marker' :
                    drawingManager.setDrawingMode(google.maps.drawing.OverlayType.MARKER);
                    break;

                case 'rectangle' :
                    drawingManager.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE);
                    break;

                case 'polygon' :
                    drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
                    break;
            }
        };



        // **************************************************************************
        // ******************************** POLYLINE / DIRECTIONS *******************
        // **************************************************************************
        function displayRoute(origin, destination) {

            var myWpt = [];
            angular.forEach(theWaypoints, function (w) {
                var obj = {
                    location: w.position,
                    stopover: false
                };
                myWpt.push(obj);
            });

            directionsService.route({
                origin: origin,
                destination: destination,
                waypoints: myWpt,
                travelMode: $scope.travelMode
            }, function (response, status) {
                if (status === 'OK') {

                    directionsDisplay.setDirections(response);

                    routeStart = null;
                    routeEnd = null;

                    currentPolylineRoute = getPolyline(response.routes[0]);

                } else {
                    currentPolylineRoute = null;
                    alert('Could not display directions due to: ' + status);
                }

                $scope.noDirection = (currentPolylineRoute === undefined);

                $scope.directionsChanged({route: currentPolylineRoute, waypoint: theWaypoints});

                $scope.$apply();
            });
        }

        function displayRouteFromDirection() {

            var direction = directionsDisplay.getDirections().request;
            if (direction) {

                var origin;
                if (direction.origin.location) {
                    origin = direction.origin.location;
                } else {
                    origin = direction.origin;
                }
                var destination;
                if (direction.destination.location) {
                    destination = direction.destination.location;
                } else {
                    destination = direction.destination;
                }
                displayRoute(origin, destination);
            }
        }


        $scope.creatingRouteChanged = function () {
            clearSelection();

            $scope.creatingRoute = !$scope.creatingRoute;

            if ($scope.creatingRoute === true) {
                if (drawingManager !== undefined) {
                    drawingManager.setDrawingMode(null);
                }
                $scope.myMap.setOptions({draggableCursor: 'crosshair'});
            } else {
                $scope.myMap.setOptions({draggableCursor: 'default'});
            }

        };

        function getRouteMarkers(routeLegs) {
            clear_route_marker();

            for (var i = 0; i < routeLegs.length; i++) {
                var marker = new google.maps.Marker({
                    map: $scope.myMap,
                    position: new google.maps.LatLng(routeLegs[i].lat(), routeLegs[i].lng()),
                    title: routeLegs[i].lat().toString() + " " + routeLegs[i].lng().toString()
                });
                theWaypoints.push(marker);
            }
        }

        function clear_route_marker() {
            for (var i = 0; i < theWaypoints.length; i++) {
                theWaypoints[i].setMap(null);
            }
            theWaypoints = [];
        }

        function deteteWayPointMarker(marker) {
            var wpts = directionsDisplay.directions.routes[0].legs[0].via_waypoints;
            marker.setMap(null);
            wpts.splice(parseInt(marker.title), 1);
            getRouteMarkers(wpts);
            displayRouteFromDirection();
        }

        function watch_waypoints() {
            clear_route_marker();

            if (!directionsDisplay.getDirections() || $.isEmptyObject(directionsDisplay.getDirections()))
                return;

            var wpts = directionsDisplay.directions.routes[0].legs[0].via_waypoints;

            for (var i = 0; i < wpts.length; i++) {
                var marker = new google.maps.Marker({
                    map: $scope.myMap,
                    position: new google.maps.LatLng(wpts[i].lat(), wpts[i].lng()),
                    title: i.toString(),
                    onRoute: true,
                    isEndpoint: false
                });
                theWaypoints.push(marker);

                google.maps.event.addListener(marker, 'click', function () {
                    setMarkerSelection(this);
                });
            }
        }

        function removeRouteMarker(markerToRemove) {
            routeStart = null;
        }

        function getPolyline(route) {

            var bounds = new google.maps.LatLngBounds();
            var points = [];

            var polyline = new google.maps.Polyline({});

            var legs = route.legs;
            for (var i = 0; i < legs.length; i++) {
                var steps = legs[i].steps;
                for (var j = 0; j < steps.length; j++) {
                    var nextSegment = steps[j].path;
                    for (var k = 0; k < nextSegment.length; k++) {
                        points.push(nextSegment[k]);
                        polyline.getPath().push(nextSegment[k]);
                        bounds.extend(nextSegment[k]);
                    }
                }
            }

            var decodedPolyline = new google.maps.Polyline({
                path: pointsFilter(points, 500)
            });

            return decodedPolyline;
        }


        function pointsFilter(points, limit) {
            var current = 0;
            var increment = 3;
            for (var i in points) {
                // var nextIndex = parseInt(i) + 1;
                var nextIndex = parseInt(i) + increment;
                var fp = points[current];
                var sp = points[nextIndex];

                if (fp && sp) {
                    var dist = getDistanceFromLatLonInKm(fp.lat(), fp.lng(), sp.lat(), sp.lng());
                    var distInMeters = dist * 1000;

                    if (distInMeters < limit && (nextIndex + increment) < points.length) {
                        points.splice(nextIndex, increment);
                    } else {
                        current = nextIndex;
                    }
                } else {
                    //
                }
            }

            return points;
        }

        function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
            var R = 6371; // Radius of the earth in km
            var dLat = deg2rad(lat2 - lat1);  // deg2rad below
            var dLon = deg2rad(lon2 - lon1);
            var a =
                    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                    Math.sin(dLon / 2) * Math.sin(dLon / 2)
                    ;
            var c = 2 * Math.atan2
                    (Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c; // Distance in km
            return d;
        }

        function deg2rad(deg) {
            return deg * (Math.PI / 180);
        }

// ******************************** POLYLINE / DIRECTIONS - end *******************
        $scope.$watch("markers", function () {
            processMarkers();

        });

        $scope.$watch("showTrafficLayer", function () {
            $scope.showHideTrafficLayer();
        });

        $scope.$watch("showTransitLayer", function () {
            $scope.showHideTransitLayer();
        });

        $scope.$watch("objLayers", function () {
            showHideOptionalLayers();
        }, true);

        $scope.showHideTrafficLayer = function () {

            if ($scope.showTrafficLayer) {
                trafficLayer.setMap($scope.myMap);
            } else {
                trafficLayer.setMap(null);
            }
        };

        $scope.showHideTransitLayer = function () {

            if ($scope.showTransitLayer) {
                transitLayer.setMap($scope.myMap);
            } else {
                transitLayer.setMap(null);
            }
        };

        $scope.deleteDirection = function () {
            if (directionsDisplay.getDirections()) {
                routeStart = null;
                routeEnd = null;

                currentPolylineRoute = null;
                $scope.directionsChanged({route: currentPolylineRoute, waypoint: theWaypoints});

                directionsDisplay.set('directions', null);
                $scope.noDirection = true;
            }
        };

        $scope.deleteSelectedShape = function () {

            if ($scope.selectedShape) {
                $scope.selectedShape.setMap(null);
                removeShapeFromList($scope.selectedShape);
            }

            if ($scope.selectedMarkerShape) {

                $scope.selectedMarkerShape.setMap(null);

                if ($scope.selectedMarkerShape.onRoute) {
                    if ($scope.selectedMarkerShape.isEndpoint) {
                        // ORIGIN
                        removeRouteMarker($scope.selectedMarkerShape);
                    } else {
                        // WAYPOINT
                        deteteWayPointMarker($scope.selectedMarkerShape);
                    }
                } else {
                    removeMarker($scope.selectedMarkerShape);
                }
            }

            clearSelection();
        };

        function markerDragEnd(marker) {
            addShapeToList(marker);
        }

        function markerDragstart(marker) {

            setMarkerSelection(marker);
            removeShapeFromList(marker);
        }

        function addShapeListener(shape) {
            // Switch back to non-drawing mode after drawing a shape.
            if (drawingManager !== undefined) {
                drawingManager.setDrawingMode(null);
            }

            // BOUNDS_CHANGED
            switch (shape.type) {
                case google.maps.drawing.OverlayType.MARKER:
                    // marker
                    google.maps.event.addListener(shape, 'dragend', function () {
                        markerDragEnd(shape);
                    });

                    google.maps.event.addListener(shape, 'dragstart', function () {
                        markerDragstart(shape);
                    });

                    break;

                case google.maps.drawing.OverlayType.RECTANGLE:
                    // rectangle
                    google.maps.event.addListener(shape, 'bounds_changed', function () {
                        onShapeBoundsChanged(shape);
                    });

                    google.maps.event.addListener(shape, 'dragstart', function () {
                        setSelection(shape);
                    });
                    break;

                case google.maps.drawing.OverlayType.POLYGON:
                    // polygon
                    google.maps.event.addListener(shape, 'dragstart', function () {
                        setSelection(shape);
                    });

                    google.maps.event.addListener(shape.getPath(), 'set_at', function () {
                        onShapeBoundsChanged(shape);
                    });
                    google.maps.event.addListener(shape.getPath(), 'insert_at', function () {
                        onShapeBoundsChanged(shape);
                    });
                    break;
            }

            // CLICK
            if (shape.type !== google.maps.drawing.OverlayType.MARKER) {
                // NON-MARKER
                google.maps.event.addListener(shape, 'click', function (e) {
                    onShapeClick(shape, e);
                });

            } else {
                // MARKER
                google.maps.event.addListener(shape, 'click', function () {
                    setSelection(shape);
                });
            }
        }

        function setContentInfo(marker) {
            var info = "";
            if ($scope.markerShowDblclickOnInfowindow) {
                info = "<div><p><b>" + marker.title + "</b></p>"
                        + "<p>" + translateFilter('gMapModule.dblClick4Details') + "</p></div>";
            } else {
                info = "<div><p><b>" + marker.title + "</b></p></div>";
            }

            markerInfoWindow.setContent(info);
        }

        function setMarkerSelection(marker) {
            clearSelection();

            $scope.selectedMarkerShape = marker;

            changeMarkerSelection(marker, true);
        }

        function clearSelection() {
            if ($scope.selectedShape) {
                if ($scope.selectedShape.type !== 'marker') {
                    $scope.selectedShape.setEditable(false);
                } else {
                    changeMarkerSelection($scope.selectedShape, false);
                }

                $scope.selectedShape = null;
            }
            if ($scope.selectedMarkerShape) {
                changeMarkerSelection($scope.selectedMarkerShape, false);
                $scope.selectedMarkerShape = null;

            }
        }

        function removeMarker(myMarker) {

            myMarker.setMap(null);
            myMarker.type = google.maps.drawing.OverlayType.MARKER;

            removeShapeFromList(myMarker);
        }

        function changeMarkerSelection(marker, isSelected) {

            var imageSize;
            var imageName;

            markerInfoWindow.close();

            if (marker.iconName) {
                imageName = marker.iconName;
                imageSize = new google.maps.Size(32, 32);

                if (isSelected) {
                    imageName = marker.iconName + "_sel";
                }

            } else {
                if (isSelected) {
                    imageName = 'marker_sel';
                    imageSize = new google.maps.Size(23, 40);
                } else {
                    marker.setIcon(null);
                    return;
                }
            }

            var imageSel = {
                url: "./assets/resources/ngDro-gMapModule/assets/statics/img/" + imageName + ".png",
                // This marker is 23 pixels wide by 40 pixels high.
                scaledSize: imageSize
            };
            marker.setIcon(imageSel);
        }

        function onShapeClick(shape, e) {
            if (e.vertex !== undefined) {
                if (shape.type === google.maps.drawing.OverlayType.POLYGON) {
                    var path = shape.getPaths().getAt(e.path);
                    path.removeAt(e.vertex);
                    if (path.length < 3) {
                        shape.setMap(null);
                    }
                }
            }

            setSelection(shape);
        }

        function onShapeBoundsChanged(shape) {

            var myShape;
            if ($scope.selectedShape !== undefined) {
                myShape = $scope.selectedShape;

            }

            if (myShape !== undefined) {
                // rimuovo la vecchia shape
                removeShapeFromList(myShape);
                // aggiungo la shape modificata
                addShapeToList(shape);
            }
        }

        function onMapClick(e) {
            clearSelection();
            $scope.$apply();

            if ($scope.creatingRoute === true) {
                placeRouteMarker(e, theWaypoints);
            }
        }


        function onOverlayComplete(e) {

            var newShape = e.overlay;

            newShape.type = e.type;
            addShapeListener(newShape);

            addShapeToList(newShape);
            setSelection(newShape);
        }

        function removeShapeFromList(shapeToRemove) {

            if (shapeToRemove.type === google.maps.drawing.OverlayType.MARKER) {
                // find marker
                for (var i = 0; i < $scope.markers.length; i++) {
                    if ($scope.markers[i].lon === shapeToRemove.position.lng() && $scope.markers[i].lat === shapeToRemove.position.lat()) {

                        $scope.markers.splice(i, 1);
                        $scope.markerChanged({markers: $scope.markers});
                        return;
                    }
                }

            } else {
                $scope.shapes.pop(shapeToRemove);
                $scope.shapeChanged({shapes: $scope.shapes});
            }
        }

        function addShapeToList(shape)
        {
            var shapeVertex = [];

            switch (shape.type) {
                case google.maps.drawing.OverlayType.MARKER:

                    var newMark = {
                        idevent: 0,
                        lon: shape.position.lng(),
                        lat: shape.position.lat()
                    };

                    $scope.markers.push(newMark);
                    $scope.markerChanged({markers: $scope.markers});
                    break;

                case google.maps.drawing.OverlayType.RECTANGLE:
                    shapeVertex = shape.bounds;
                    break;

                case google.maps.drawing.OverlayType.POLYGON:
                    shapeVertex = shape.latLngs;
                    break;

                default:
                    return;
            }

            var newShape = new function () {
                this.shapeType = shape.type;
                this.vertex = shapeVertex;
            };

            if (shape.type !== google.maps.drawing.OverlayType.MARKER) {
                $scope.shapes.push(newShape);
                $scope.shapeChanged({shapes: $scope.shapes});
            }
        }

        function setSelection(shape) {
            clearSelection();

            if (shape.type !== 'marker') {
                shape.setEditable(true);
                $scope.selectedShape = shape;

            } else {
                // marker
                changeMarkerSelection(shape, true);
                $scope.selectedMarkerShape = shape;

            }

            $scope.$apply();
        }

        function placeRouteMarker(e) {

            var myLatlng = new google.maps.LatLng(e.latLng.lat(), e.latLng.lng());
            var newMark = new google.maps.Marker({
                title: e.latLng.lat().toString() + " " + e.latLng.lng().toString(),
                position: myLatlng,
                onRoute: true,
                isEndpoint: false
            });

            if (directionsDisplay.getDirections()) {
                watch_waypoints();

                theWaypoints.push(newMark);
                displayRouteFromDirection();

            } else {

                newMark.addListener('click', function (e) {
                    setMarkerSelection(newMark);
                });

                if (!routeStart) {

                    newMark.setMap($scope.myMap);
                    newMark.setAnimation(google.maps.Animation.DROP);

                    routeStart = newMark;
                    newMark.isEndpoint = true;
                } else {
                    if (!routeEnd) {
                        newMark.setMap($scope.myMap);
                        newMark.setAnimation(google.maps.Animation.DROP);

                        routeEnd = newMark;
                        newMark.isEndpoint = true;
                    } else {
                        // waypoint
                        newMark.setMap(null);
                        theWaypoints.push(newMark);
                    }

                    routeStart.setMap(null);
                    routeEnd.setMap(null);

                    displayRoute(routeStart.position, routeEnd.position);
                }
            }
        }

        function selectMarker(marker) {
            setContentInfo(marker);
            setMarkerSelection(marker);

            if ($scope.parentObjEditable === false) {

                //prima di aprire l'infoWindow verifico la risoluzione, così la visualizzo correttamente anche su device e catturo anche la rotazione
                var windowWidth = $(window).outerWidth();
                var infoWindowOptions = {
                    maxWidth: windowWidth - 150
                };
                markerInfoWindow.setOptions(infoWindowOptions);

                markerInfoWindow.open($scope.myMap, marker);
            }
        }
        ;

        function clearMarkers() {
            if ($scope.mapMarkers) {
                for (var i = 0; i < $scope.mapMarkers.length; i++) {
                    $scope.mapMarkers[i].setMap(null);
                }
            }

            $scope.mapMarkers = [];
        }
        function processMarkers() {


            clearMarkers();
            // ******************************************************
            // load parent markers (situation record)
            // ******************************************************
            if ($scope.myMap && $scope.markers && $scope.markers.length > 0) {


                angular.forEach($scope.markers, function (obj) {

                    var myLatlng = new google.maps.LatLng(obj.lat, obj.lon);
                    var image;

                    if (obj.icon && !obj.icon.isEmpty) {
                        image = {
                            url: "./assets/resources/ngDro-gMapModule/assets/statics/img/" + obj.icon + ".png",
                            scaledSize: new google.maps.Size(32, 32)
                        };
                    }

                    var marker = new google.maps.Marker({
                        idevent: obj.idevent,
                        position: myLatlng,
                        title: obj.description,
                        map: $scope.myMap,
                        icon: image,
                        iconName: obj.icon,
                        draggable: $scope.parentObjEditable,
                        type: google.maps.drawing.OverlayType.MARKER
                    });

                    // marker events
                    marker.addListener('click', function () {
                        selectMarker(this);
                        $scope.markerClickEvent({marker: marker});
                    });


                    marker.addListener('dragend', function () {
                        markerDragEnd(this);
                    });

                    marker.addListener('dragstart', function () {
                        markerDragstart(this);
                    });

                    marker.addListener('dblclick', function (e) {
                        $scope.markerOpenEvent({marker: marker});
                    });

                    $scope.mapMarkers.push(marker);

                });

            }
        }

        /**
         * activeEventId: evento viene selezionato dall'esterno
         */
        $scope.$watch("activeEventId", function () {

            if ($scope.activeEventId) {
                angular.forEach($scope.mapMarkers, function (marker) {
                    if (marker.idevent === $scope.activeEventId) {
                        selectMarker(marker);
                    }
                });
            }

        });

    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-gMapModule/components/mapDirective/mapDirectiveCtrl.js
// module id = 328
// module chunks = 0